var map = {
	"./beef-steak.png": [
		4382,
		382
	],
	"./bicycle.png": [
		9919,
		919
	],
	"./bus.png": [
		1385,
		385
	],
	"./car.png": [
		5966,
		966
	],
	"./carrot.png": [
		9817,
		817
	],
	"./coffee.png": [
		2023,
		23
	],
	"./fried-chicken.png": [
		8199,
		199
	],
	"./grapes.png": [
		646,
		646
	],
	"./jeans.png": [
		9015,
		15
	],
	"./multimedia.png": [
		5734,
		734
	],
	"./plane.png": [
		1209,
		209
	],
	"./salad.png": [
		7305,
		305
	],
	"./shoes.png": [
		6454,
		454
	],
	"./soda.png": [
		1047,
		47
	],
	"./t-shirt.png": [
		6701,
		701
	],
	"./tea.png": [
		8803,
		803
	],
	"./train.png": [
		2347,
		347
	],
	"./tram.png": [
		4403,
		403
	],
	"./water-bottle.png": [
		8250,
		250
	],
	"./water-tap.png": [
		8710,
		710
	],
	"./wine-bottle.png": [
		7456,
		456
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3342;
module.exports = webpackAsyncContext;